import React from 'react';
import { View } from 'react-native';
import { Text } from '~/components';

interface InfoItemProps {
  description: string;
}

const InfoItem: React.FC<InfoItemProps> = ({ description }) => {
  return (
    <View className="flex-row">
      <View className="h-1 w-1 rounded-full bg-gray-400 mx-2 mt-2" />
      <Text className="text-gray-400 text-xs flex-1">{description}</Text>
    </View>
  );
};

export default InfoItem;
